import PropTypes from "prop-types";
import "app/pages/.shared/Page/page.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const Page = ({ title, variant, children }) => {
	return (
		<div className={`page page--${variant}`}>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				isBold
				className="page__title"
				component="h1"
			>
				{title}
			</Typography>
			<section className="page__content">{children}</section>
		</div>
	);
};

Page.propTypes = {
	variant: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default Page;
